export const preloadImage = (src: string, timeout = 3000) =>
  new Promise<void>((resolve) => {
    const image = new Image()
    const timer = setTimeout(resolve, timeout)
    const settle = () => {
      clearTimeout(timer)
      resolve()
    }

    image.onload = settle
    image.onerror = settle
    image.src = src
  })
